import { Maybe, Seo as HygraphSeo } from '@/lib/types';

import { HygraphImageProps } from '@/components/hygraph-image';
import { defaultMeta } from '@/components/Seo';

import imageTransformer from '@/hygraph/transformers/image.transformer';

export type SeoProps = Omit<HygraphSeo, 'image' | 'id' | 'stage'> & {
  image?: HygraphImageProps;
};

export default function seoTransformer(
  seo?: Maybe<HygraphSeo>,
  defaults: Partial<HygraphSeo> = {}
): SeoProps {
  const title = seo?.title || defaults.title;
  const description = seo?.description || defaults.description;
  const image = imageTransformer(seo?.image || defaults.image) || {
    url: defaultMeta.image,
    description: 'Nomad Health',
  };

  return {
    keywords: seo?.keywords || [],
    noIndex: !!seo?.noIndex,
    ...(title && { title }),
    ...(description && { description }),
    ...(image && { image }),
  };
}
